import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { message } from 'antd'
import { client } from '@utils/client'
import Modal from '@components/Modal'

import { wellKidzClubButton, wellKidzClubModal } from './List'
import Text from '@components/Text'
import { ThemeContext } from '@contexts/ThemeContext'
import ErrorSvg from '@image/icons/ErrorSvg'
import { Button } from 'antd'
const SuspendAccount = (props) => {
  const { wellClubId, open, setOpen, reload } = props
  const { t } = useLocalization()
  const { theme } = useContext(ThemeContext)

  // const history = useHistory()
  // const params = useParams()

  const handleSubmit = async () => {
    try {
      // ;(ACTIVE = 'ACTIVE'),
      //   (BANNED = 'BANNED'),
      //   (EXPIRED = 'EXPIRED'),
      await client.patch(`/wellkidzclub/${wellClubId}/status`, {
        status: 'BANNED',
      })
      message.success('สำเร็จ')
      reload()
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }

  /**
   * @type {{
   * footer: React.CSSProperties,
   * body: React.CSSProperties,
   * btn: React.CSSProperties }}
   */

  const style = {
    body: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
    footer: {
      display: 'flex',
      justifyContent: 'space-around',
      paddingTop: 24,
      gap: 8,
    },

    btn: {
      borderRadius: '8px',
      width: '170px',
      height: '40px',
      fontWeight: '600',
    },
  }
  return (
    <>
      <Modal
        centered={true}
        open={open}
        onCancel={() => setOpen(false)}
        closable={false}
        maskClosable={false}
        // footer={null}
        width={420}
        bodyStyle={{ padding: 40, overflowY: 'hidden', gap: 24 }}
      >
        <div style={style.body}>
          <ErrorSvg width={72} height={86} />
          <Text level={1} type="danger" semi>
            {t(`${wellKidzClubModal}.suspendConfirmQuestion`)}
          </Text>
          <Text
            level={3}
            color={theme.text.black}
            style={{ textAlign: 'center' }}
            semi
          >
            {t(`${wellKidzClubModal}.suspendWarning`)}
          </Text>
        </div>
        <div style={style.footer}>
          <Button
            key="cancelSuspendWarning"
            onClick={() => setOpen(false)}
            style={style.btn}
          >
            <Text level={3} color={theme.text.darkGrey} semi>
              {t(`${wellKidzClubButton}.back`)}
            </Text>
          </Button>
          <Button
            type="primary"
            danger
            key="confirmSuspendWarning"
            onClick={() => handleSubmit()}
            style={style.btn}
          >
            <Text level={3} color={theme.text.white} semi>
              {t(`${wellKidzClubButton}.confirm`)}
            </Text>
          </Button>
        </div>
      </Modal>
    </>
  )
}

SuspendAccount.propTypes = {
  defaultValues: PropTypes.object,
  reload: PropTypes.func,
  setOpen: PropTypes.func,
  open: PropTypes.bool,
  wellClubId: PropTypes.string,
}

export default SuspendAccount
